import { getGameState, saveGameState } from './state.js';
import { eventBus, GameEvents } from './events.js';

export const UPGRADE_DEFS = {
  ocean_current: {
    id: 'ocean_current',
    name: 'Ocean Current',
    icon: '\u{1F30A}',
    description: 'Doubles driftwood spawn rate. Random resource appears at water edge every 60s.',
    cost: { gem: 5, driftwood: 5 },
    effects: {
      driftwoodSpawnMultiplier: 2,
      waterEdgeSpawnInterval: 60, // seconds
    },
  },
  island_expansion_1: {
    id: 'island_expansion_1',
    name: 'Island Expansion I',
    icon: '\u{1F3DD}\uFE0F',
    description: 'Expand your island by 20%. New palm trees sprout on the expanded land. +5 object placement slots.',
    cost: { gem: 15, coconut: 10 },
    effects: {
      terrainRadiusMultiplier: 1.2,
      additionalPalmTrees: 3,
      additionalObjectSlots: 5,
    },
  },
};

export function purchaseUpgrade(upgradeId) {
  const def = UPGRADE_DEFS[upgradeId];
  if (!def) return false;

  const state = getGameState();
  if (state.upgrades[upgradeId]) return false; // already purchased

  // Check cost (deduction handled by caller)
  state.upgrades[upgradeId] = { purchased: true, timestamp: Date.now() };
  saveGameState(state);

  eventBus.emit(GameEvents.UPGRADE_PURCHASED, { upgradeId, upgrade: def });
  return true;
}

export function hasUpgrade(upgradeId) {
  return !!getGameState().upgrades[upgradeId]?.purchased;
}

export function getUpgradeDef(upgradeId) {
  return UPGRADE_DEFS[upgradeId] || null;
}
